var _ellipse, _ellipse2, _ellipse3, _path, _path2, _ellipse4, _ellipse5, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIec62196T3C = function SvgIec62196T3C(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.24345,
    cy: 7.50603,
    rx: 0.411666,
    ry: 0.434554,
    fill: "#29314F"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.1102,
    cy: 13.0506,
    rx: 0.411666,
    ry: 0.434554,
    fill: "#29314F"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.20634,
    cy: 10.2803,
    rx: 0.411666,
    ry: 0.434554,
    fill: "#29314F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.24052 5.4135C8.41494 5.4135 8.55684 5.26371 8.55684 5.07998C8.55684 4.89625 8.41494 4.74646 8.24052 4.74646C8.06646 4.74646 7.92456 4.89625 7.92456 5.07998C7.92493 5.2641 8.06683 5.4135 8.24052 5.4135Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9876 2H9.01165C7.1514 2 5.62964 3.60637 5.62964 5.57005V14.4304C5.62964 16.3941 7.1514 18.0005 9.01165 18.0005H10.9876C12.8478 18.0005 14.3696 16.3941 14.3696 14.4304V5.57005C14.3696 3.60637 12.8478 2 10.9876 2ZM11.7602 4.17354C12.2344 4.17354 12.6194 4.58001 12.6194 5.08009C12.6194 5.57979 12.234 5.98665 11.7602 5.98665C11.2865 5.98665 10.9014 5.58018 10.9014 5.08009C10.9018 4.58001 11.2869 4.17354 11.7602 4.17354ZM8.24071 4.17354C8.71482 4.17354 9.09988 4.58001 9.09988 5.08009C9.09988 5.57979 8.71445 5.98665 8.24071 5.98665C7.76733 5.98665 7.3819 5.58018 7.3819 5.08009C7.3819 4.58001 7.76696 4.17354 8.24071 4.17354ZM7.05288 7.50609C7.07099 6.81408 7.58686 6.25041 8.24316 6.25041C8.89946 6.25041 9.43344 6.81369 9.43344 7.50609C9.43344 8.19849 8.89946 8.78167 8.24316 8.76255C7.56728 8.74227 7.03551 8.18094 7.05288 7.50609ZM8.20616 11.5364C7.53027 11.5165 6.99851 10.9551 7.01587 10.2799C7.03398 9.5879 7.54986 9.02423 8.20616 9.02423C8.86246 9.02423 9.39644 9.58751 9.39644 10.2799C9.39644 10.9723 8.86246 11.5559 8.20616 11.5364ZM10.11 14.3072C9.43415 14.2873 8.90239 13.726 8.91976 13.0508C8.93786 12.3587 9.45374 11.7951 10.11 11.7951C10.7663 11.7951 11.3003 12.3584 11.3003 13.0508C11.3003 13.7432 10.7663 14.3267 10.11 14.3072ZM11.7627 11.5364C11.0868 11.5165 10.555 10.9551 10.5724 10.2799C10.5905 9.5879 11.1064 9.02423 11.7627 9.02423C12.419 9.02423 12.953 9.58751 12.953 10.2799C12.953 10.9723 12.4186 11.5559 11.7627 11.5364ZM11.7627 8.7621C11.0868 8.7422 10.555 8.18087 10.5724 7.50563C10.5905 6.81363 11.1064 6.24995 11.7627 6.24995C12.419 6.24995 12.953 6.81324 12.953 7.50563C12.953 8.19803 12.4186 8.7816 11.7627 8.7621Z",
    fill: "currentColor"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.7625,
    cy: 10.2803,
    rx: 0.411666,
    ry: 0.434554,
    fill: "currentColor"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.7625,
    cy: 7.50603,
    rx: 0.411666,
    ry: 0.434554,
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7603 5.4135C11.9347 5.4135 12.0766 5.26371 12.0766 5.07998C12.0766 4.89625 11.9347 4.74646 11.7603 4.74646C11.5862 4.74646 11.4443 4.89625 11.4443 5.07998C11.4443 5.2641 11.5866 5.4135 11.7603 5.4135Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2786 0H8.7214C5.98016 0 3.75 2.35416 3.75 5.2478V14.7522C3.75 17.6458 5.98016 20 8.7214 20H11.2786C14.0198 20 16.25 17.6458 16.25 14.7522V5.2478C16.25 2.35416 14.0198 0 11.2786 0ZM15.2892 14.7522C15.2892 17.0864 13.49 18.9857 11.2786 18.9857H8.72143C6.51011 18.9857 4.71083 17.0864 4.71083 14.7522V5.24776C4.71083 2.91349 6.51011 1.01418 8.72143 1.01418H11.2786C13.49 1.01418 15.2892 2.91349 15.2892 5.24776V14.7522Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIec62196T3C);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Iec62196T3C.ee8f7d6f1be3e64284072bdb4524e15b.svg";